"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _context;

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

var _exportNames = {
  help: true,
  signatory: true,
  themes: true,
  user: true,
  getStaffAvailability: true,
  removeFavorite: true,
  addFavorite: true,
  changeAvailability: true,
  getStaffDetail: true
};

_Object$defineProperty(exports, "getStaffAvailability", {
  enumerable: true,
  get: function get() {
    return _staffAvailability.getStaffAvailability;
  }
});

_Object$defineProperty(exports, "removeFavorite", {
  enumerable: true,
  get: function get() {
    return _staffAvailability.removeFavorite;
  }
});

_Object$defineProperty(exports, "addFavorite", {
  enumerable: true,
  get: function get() {
    return _staffAvailability.addFavorite;
  }
});

_Object$defineProperty(exports, "changeAvailability", {
  enumerable: true,
  get: function get() {
    return _staffAvailability.changeAvailability;
  }
});

_Object$defineProperty(exports, "getStaffDetail", {
  enumerable: true,
  get: function get() {
    return _staffAvailability.getStaffDetail;
  }
});

exports.user = exports.themes = exports.signatory = exports.help = void 0;

var _help = _interopRequireWildcard(require("./help"));

var _signatory = _interopRequireWildcard(require("./signatory"));

var _themes = _interopRequireWildcard(require("./themes"));

var _user = _interopRequireWildcard(require("./user"));

var _models = require("./models");

_forEachInstanceProperty(_context = _Object$keys(_models)).call(_context, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _models[key];
    }
  });
});

var _staffAvailability = require("./staff-availability");

var help = _help;
exports.help = help;
var signatory = _signatory;
exports.signatory = signatory;
var themes = _themes;
exports.themes = themes;
var user = _user;
exports.user = user;
